import {Link} from 'react-router-dom';
import { useState } from 'react'
import ConfirmationPage from '../ConfirmationPage.js';

export default function Form() {
    let [Click, setClick] = useState(false)

    let handleBookingPageClick = function () {
        setClick(!Click)
    }

    return(
        <>
        <form class="BP-Form">
            <h1>Book a Time with Tutor</h1>
            <div>
                <div>
                    <label for='email'>E-Mail</label>
                    <input type="text" id='email' name='E-Mail'/>
                </div>
                <div>
                    <label for='location'>Location</label>
                    <input type="text" id='location' name='Location'/>
                </div>
            </div>
            <div>
                <div>
                    <label for='pnumber'>Phone Number</label>
                    <input type="text" id='pnumber' name='Phone Number'/>
                </div>
                <div>
                    <label for='time'>Time</label>
                    <input type="text" id='time' name='Time'/>
                </div>
            </div>
            <Link style={{textDecoration: 'none'}} class="Button" onClick={handleBookingPageClick}>Submite</Link>
            <ConfirmationPage Click={Click} Close={handleBookingPageClick}></ConfirmationPage>
        </form>
        </>
    )
}